module.exports = new __parcel__URL__("time_icon.daa280aa.png").toString();